import React from 'react';
import PropTypes from 'prop-types';
import { isFieldVisible } from 'Components/UI/Meta/isFieldVisible';
import { FDPaper, FDStack } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Stat } from 'Packages/FacetDesign/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .typeOverride('number', { _component: () => Stat }, overrideReadOnly);

export function MobileInterestCard({ managedAccountPageResource, activitySummary }) {
  const isMobile = useMobileLayout();
  if (!isMobile) {
    return null; // This is just for mobile devices
  }
  if (!activitySummary || !managedAccountPageResource) {
    return null; // We need the above resources to have been loaded first - we could be missing activitySummary for example
  }
  if (!isFieldVisible(activitySummary, activitySummary.metaField('accruedInterestAllTime'))) {
    return null; // If we shouldn't be showing interest, then we shouldn't render this whole component
  }
  return (
    <FDPaper padding={4}>
      <FDStack direction="row" justifyContent="space-between">
        <MetaControl resource={activitySummary} attrName="accruedInterestAllTime" metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={managedAccountPageResource} attrName="apy" metaOverrideSet={metaOverrideSet} />
      </FDStack>
    </FDPaper>
  );
}

MobileInterestCard.defaultProps = {
  managedAccountPageResource: undefined,
  activitySummary: undefined,
};
MobileInterestCard.propTypes = {
  managedAccountPageResource: PropTypes.object,
  activitySummary: PropTypes.object,
};
